import { createStyles, makeStyles } from '@material-ui/core/styles'
import { colors } from 'Themes/Colors'

interface Props {
  style?: {
    textAlign?: string
  }
}

const useStyles = makeStyles(() =>
  createStyles({
    inputRoot: {
      'label[data-shrink=false] + & ::-webkit-input-placeholder': {
        opacity: '0.5 !important',
      },
    },
    input: {
      '& input[type=number]': {
        textAlign: (props: Props) =>
          props?.style?.textAlign ? props?.style?.textAlign : 'right',
      },
      '& .Mui-disabled': {
        backgroundColor: colors.lightestGrey,
      },
      '& .MuiOutlinedInput-multiline': {
        padding: 0,
        ' & textarea': {
          padding: '10px 12px',
        },
      },
      '& .MuiFormHelperText-contained': {
        fontSize: '12.8px',
        lineHeight: '17.28px',
        fontFamily: '"Source Sans Pro", sans-serif',
      },
    },
    red: {
      color: colors.red,
    },
  })
)

export default useStyles
